import * as React from "react";
const SvgStopbutton = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={12} fill="none" {...props}>
    <path fill="#EDF1F7" d="M.5 0h12v12H.5z" />
    <path fill="#A9B6CB" fillRule="evenodd" d="M11.75.75H1.25v10.5h10.5V.75ZM.5 0v12h12V0H.5Z" clipRule="evenodd" />
  </svg>
);
export default SvgStopbutton;